import React from "react";
import { useNavigate } from "react-router-dom";
import "./Logo.css";

const Logo = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
  };
  return (
    <div className="logo" onClick={handleLogoClick}>
      <img src="logo-noback.png" alt="Company Logo" />
    </div>
  );
};

export default Logo;
